import { HtmlContent } from '@servicetitan/financing-utils-shared';
import * as styles from './GreenSkyPreApprovalDisclosure.module.scss';

interface GreenSkyPreApprovalDisclosureProps {
    /** GreenSky's `General` prescreen disclosure body; may contain provider HTML markup. */
    text: string;
    className?: string;
}

/**
 * GreenSky's FCRA prescreen notice: a bold "PRESCREEN & OPT-OUT NOTICE:" label and the sanitized
 * API `General` body, rendered in a muted card. The "PRESCREEN & OPT-OUT NOTICE:" label is static
 * UI; only the body comes from the API and is sanitized via {@link HtmlContent}.
 *
 * The Equal Opportunity Lender mark is intentionally NOT shown here. On the application plans page it
 * renders with the standard footer disclosure below this notice; in the prequals-banner it is omitted
 * entirely.
 */
export const GreenSkyPreApprovalDisclosure = ({
    text,
    className,
}: GreenSkyPreApprovalDisclosureProps) => {
    if (!text) {
        // Defensive: the banner is already suppressed when the General disclosure is absent.
        return null;
    }

    const cardClassName = [styles.card, className].filter(Boolean).join(' ');

    return (
        <div className={cardClassName}>
            {/* Plain div wrapper (not Anvil Text) so HtmlContent's block body isn't nested in a <p>.
                The label and body flow inline as one bold paragraph (see the .body styles). */}
            <div className={styles.body}>
                <strong>PRESCREEN &amp; OPT-OUT NOTICE:</strong> <HtmlContent content={text} />
            </div>
        </div>
    );
};
